<template>

  <b-row>
    <b-col
      cols="12"
      md="12"
    >
      <h2>Assembleias</h2>
      <p>
        Fique atento com as datas das assembleias para não perder nenhuma votação importante.
      </p>
    </b-col>
    <b-col
      cols="12"
      md="12"
    >
      <b-tabs class="w-100">
        <b-tab
          title="Iniciadas"
          active
        >
          <assembleia-list
            v-if="!loading"
            :assembleias="assembleias"
            @assembleiaClick="visualizarAssembleia"
          />
        </b-tab>
        <b-tab title="Encerradas">
          <assembleia-list
            v-if="!loading"
            :assembleias="assembleiasEncerradas"
            @assembleiaClick="visualizarAssembleia"
          />
        </b-tab>
      </b-tabs>
    </b-col>
  </b-row>
</template>

<script>
import AssembleiaAPI from '@/api/assembleia'
import AssembleiaList from '../components/AssembleiaList.vue'

export default {
  components: {
    AssembleiaList,
  },
  data() {
    return {
      assembleias: [],
      assembleiasEncerradas: [],
      loading: true,
    }
  },
  created() {
    this.listAssembleia()
  },
  methods: {
    async listAssembleia() {
      try {
        this.$loading.show()
        this.loading = true
        const {
          data: { content: assembleias },
        } = await AssembleiaAPI.listAssembleia({ situacao: 'INICIADA' })
        this.assembleias = assembleias

        const {
          data: { content: assembleiasEncerradas },
        } = await AssembleiaAPI.listAssembleia({ situacao: 'ENCERRADA' })
        this.assembleiasEncerradas = assembleiasEncerradas
      } finally {
        this.loading = false
        this.$loading.hide()
      }
    },
    visualizarAssembleia(assembleiaId) {
      this.$router.push(`/assembleias/votacao/${assembleiaId}`).catch(() => {})
    },
  },
}
</script>
